import { gql } from 'graphql-tag';

export const GET_PAYABLES = gql`
  query Id690165dd5f743de3fb960866cc8aae50(
    $companyId: ID!
    $after: ID
    $filtersV2: JSON
    $textualSearch: String
    $sort: Sort
  ) {
    __typename
  }
`;
